import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ordenCompraApi } from "@/features/seleccionar-orden-compra/services/orden-compra.api";
import { qk } from "@/lib/query-keys";
import { toastError, toastExito } from "@/lib/toast";
import { extractApiMessage } from "@/shared/api/extract-message";

/**
 * Mutation para asociar la orden de compra (OC) · al éxito hidrata el cache de la
 * solicitud (el backend devolvió el detalle con `ordenCompra` poblado y estado
 * `OrdenDeCompraSeleccionada`). La navegación queda a cargo del caller.
 */
export function useSeleccionarOrdenDeCompra(
  solicitudId: string,
  options?: { onSuccess?: () => void }
) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (clave: string) => ordenCompraApi.seleccionar(solicitudId, clave),
    onSuccess: (solicitud) => {
      qc.setQueryData(qk.solicitud(solicitudId), solicitud);
      toastExito({ title: "Orden de compra asociada", message: `OC ${solicitud.ordenCompra?.clave ?? ""} · continúa con la carga del CFDI.` });
      options?.onSuccess?.();
    },
    onError: (e) => toastError({ title: "No se pudo asociar la orden de compra", message: extractApiMessage(e, "Revisa la clave de la orden de compra.") }),
  });
}
